import { Route, Routes } from "react-router-dom"
import { LoginFactory } from "pages/factory/safety/login-factory"
import ErrorAuthenticationTokenPage from "pages/layout/error/error-authentication-token-page"
import { ResetPasswordFactory } from "pages/factory/safety/reset-password-factory"
import { OnlineConsultantAnalyticalFactory } from "pages/factory/analysis/online-consultant-analytical-factory"
import { useHeader } from "data/context/header-context"
import { LogoutRoute } from "pages/layout/safety/logout-route"

export function Public() {
    const { hideHeader } = useHeader();
    hideHeader();

    return (
        <Routes>
            <Route path='*' element={<ErrorAuthenticationTokenPage />} />
            <Route path="/" element={<LoginFactory />} />
            <Route path="/reset-password" element={<ResetPasswordFactory />} />
            <Route path="/comanalisaranalitico" element={<OnlineConsultantAnalyticalFactory />} />
            <Route path="/logout" element={<LogoutRoute />} />
        </Routes>
    )
}

export default Public